import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { Device } from "../../../../constants/device";
import { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import useMediaWithDevice from "../../../../hooks/use-media-with-device";
import SubMenu from "../sub-menu/sub-menu";
import VerticalCaret from "../vertical-caret/vertical-caret";
import { useMenuContext } from "../../mega-menu-provider";
import { TopMenuButton, TopMenuItemContainer } from "./top-menu.styles";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TrimmedLabel = /*#__PURE__*/memo(function (_ref) {
  var label = _ref.label,
    trimmed = _ref.trimmed;
  var shouldShowTrimmedLabel = useMediaWithDevice("(max-width: ".concat(trimmed.threshold, ")"), Device.Mobile);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: shouldShowTrimmedLabel && trimmed.label ? trimmed.label : label
  });
});
var TopMenuItem = function TopMenuItem(_ref2) {
  var palette = _ref2.palette,
    item = _ref2.item,
    isActive = _ref2.isActive,
    onMenuOpen = _ref2.onMenuOpen,
    onMenuClose = _ref2.onMenuClose,
    onSubMenuItemClick = _ref2.onSubMenuItemClick,
    subMenuElementRef = _ref2.subMenuElementRef;
  var label = item.label,
    trimmedLabel = item.trimmedLabel,
    href = item.href,
    target = item.target,
    items = item.items,
    layout = item.layout,
    seeMoreLink = item.seeMoreLink;
  var _useMenuContext = useMenuContext(),
    isMobileMenu = _useMenuContext.isMobileMenu;
  var elementRef = useRef(null);
  var handleMenuOpen = useCallback(function (event) {
    return onMenuOpen === null || onMenuOpen === void 0 ? void 0 : onMenuOpen({
      item: item,
      event: event
    });
  }, [item, onMenuOpen]);
  var handleMenuClose = useCallback(function (event) {
    return onMenuClose === null || onMenuClose === void 0 ? void 0 : onMenuClose({
      item: item,
      event: event
    });
  }, [item, onMenuClose]);
  var handleMenuBlur = useCallback(function (event) {
    if (event.currentTarget.contains(event.relatedTarget)) {
      return;
    }
    handleMenuClose(event);
  }, [handleMenuClose]);
  var _useMemo = useMemo(function () {
      if (!items) {
        return {
          buttonProps: {
            onClick: function onClick(event) {
              return onSubMenuItemClick === null || onSubMenuItemClick === void 0 ? void 0 : onSubMenuItemClick({
                item: item,
                event: event
              });
            }
          }
        };
      }
      var buttonProps = {
        'aria-haspopup': true,
        'aria-expanded': isActive,
        'onClick': isActive ? handleMenuClose : handleMenuOpen
      };
      var listProps = !isMobileMenu ? {
        onMouseEnter: handleMenuOpen,
        onMouseLeave: handleMenuClose,
        onBlur: handleMenuBlur
      } : {};
      return {
        buttonProps: buttonProps,
        listProps: listProps
      };
    }, [item, items, isActive, isMobileMenu, handleMenuOpen, handleMenuClose, handleMenuBlur, onSubMenuItemClick]),
    listProps = _useMemo.listProps,
    buttonProps = _useMemo.buttonProps;
  useEffect(function () {
    if (!isActive || isMobileMenu) {
      return;
    }
    var exitKeyHandler = function exitKeyHandler(event) {
      if (event.key === 'Escape') {
        handleMenuClose(event);
      }
    };
    window.addEventListener('keydown', exitKeyHandler);
    return function () {
      window.removeEventListener('keydown', exitKeyHandler);
    };
  }, [isActive, handleMenuClose, isMobileMenu]);
  var handleScrollToSubMenu = function handleScrollToSubMenu(event) {
    if (event.propertyName === 'max-height' && elementRef.current) {
      var _elementRef$current$p;
      (_elementRef$current$p = elementRef.current.parentElement) === null || _elementRef$current$p === void 0 ? void 0 : _elementRef$current$p.scrollTo({
        top: elementRef.current.offsetTop,
        behavior: 'smooth'
      });
    }
  };
  return /*#__PURE__*/_jsxs(TopMenuItemContainer, _objectSpread(_objectSpread({
    ref: elementRef,
    palette: palette,
    isActive: isActive
  }, listProps), {}, {
    children: [/*#__PURE__*/_jsxs(TopMenuButton, _objectSpread(_objectSpread({
      href: href,
      target: target
    }, buttonProps), {}, {
      children: [trimmedLabel ? /*#__PURE__*/_jsx(TrimmedLabel, {
        label: label,
        trimmed: trimmedLabel
      }) : label, items && /*#__PURE__*/_jsx(VerticalCaret, {})]
    })), items && /*#__PURE__*/_jsx(SubMenu, {
      ref: subMenuElementRef,
      layout: layout,
      palette: palette,
      items: items,
      seeMoreLink: seeMoreLink,
      isActive: isActive,
      onItemClick: onSubMenuItemClick,
      onTransitionEnd: isMobileMenu && isActive ? handleScrollToSubMenu : undefined
    })]
  }));
};
export default /*#__PURE__*/memo(TopMenuItem);